import React from "react";
import styled from "styled-components";

const Container = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
  color: #111827;
  font-size: 13px;
`;

const Thead = styled.thead`
`;

const Th = styled.th`
  background-color: #dce9fb;
  padding: 13px 16px;
  text-align: left;
  font-weight: 700;
  color: #1f3556;
  line-height: 1.25;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

const Td = styled.td`
  padding: 13px 16px;
  border-bottom: 1px solid #d8dee6;
  vertical-align: top;
  line-height: 1.35;
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: #f7f9fb;
  }

  &:last-child td {
    border-bottom: none;
  }
`;

const OurTeamContent = () => {
  const data = [
    ["01", "Dr. Abha Rani Singh, IRS", "Chairman-Cum-Managing Director", "+91-11-22441635", "cmd[Dot]nmdfc[at]gmail[Dot]com"],
    ["02", "Sh Anil Kumar", "General Manager (Project / Legal & Recovery)", "+91-11-22460253", "a[Dot]kumar28[at]nic[Dot]in"],
    ["03", "Sh. Kumar Sudesh", "General Manager (Fin. And Coordination)", "+91-11-22441438", "k[Dot]sudesh27[at]nic[Dot]in"],
    ["04", "Sh Nixon Mathur", "General Manager (Planning/Social Media/Chief Vigilance Officer)", "+91-11-22441435", "n[Dot]mathur28[at]nic[Dot]in"],
    ["05", "Sh Manoj Punia", "General Manager (Accounts/Marketing)", "+91-11-22040667", "m[Dot]punia29[at]nic[Dot]in"],
    ["06", "Sh P.S. Pawnikar", "Dy. Gen. Manager (System & Skill Dev./OL/Records Mngt/H&A)", "+91-11-22441453", "ps[Dot]pawnikar29[at]nic[Dot]in"],
    ["07", "Sh Sachin Kumar", "Asst. Gen. Manager (Finance/Planning)", "+91-11-22441442", "s[Dot]kumar41[at]nic[Dot]in"],
    ["08", "Sh. D. Das", "Asst. Gen. Manager (H&A) / PIO", "+91-11-22441455", "d[Dot]das27[at]nic[Dot]in"],
    ["09", "Sh. Jauedul Hasan", "Asst. Gen. Manager (Accounts)", "+91-11-22441442", "j[Dot]hasan39[at]nic[Dot]in"],
    ["10", "Sh. S.M. Jha", "Manager (Coordination/Records Management)", "+91-11-22441442", "sm[Dot]jha31[at]nic[Dot]in"],
    ["11", "Sh. Pradeep Kr. Gupta", "Manager (Official Language/Marketing)", "+91-11-22441442", "pradeepgupta111[at]yahoo[Dot]co[Dot]in"],
    ["12", "Sh. Harish Sharma", "Manager (Pub. & Social Media/CSR)", "+91-11-22441442", "h[Dot]sharma51[at]nic[Dot]in"],
    ["13", "Sh. Vikas Khatri", "Dy. Manager (Accounts)", "+91-11-22441442", "vk[Dot]nmdfc[at]gmail[Dot]com"],
    ["14", "Sh. Narendra Kumar Nitharwal", "Dy. Manager (Finance/Legal & Recovery)", "+91-11-22441442", "nk[Dot]nmdfc[at]gmail[Dot]com"],
    ["15", "Sh. Rajan Yadav", "Dy. Manager (Systems & Skill Dev.)", "+91-11-22441442", "r[Dot]yadav53[at]nic[Dot]in"],
    ["16", "Smt. Sharmeen Qureshi", "Dy. Manager (Accts)", "+91-11-22441442", "sharmeenq30[at]govcontractor[Dot]in"],
    ["17", "Sh. Vipin Nijhawan", "Dy. Manager (Project / Legal & Recovery)", "+91-11-22441442", "vip[Dot]nijh[at]rediffmail[Dot]com"],
    ["18", "Sh. Dharmender Kumar", "Dy. Manager (Fin.)", "+91-11-22441442", "d[Dot]kumar30[at]nic[Dot]in"],
    ["19", "Sh. Vinod Kumar Prajapati", "Dy. Manager (Systems)", "+91-11-22441442", "v[Dot]prajapati41[at]nic[Dot]in"],
    ["20", "Sh. Sushil Saini", "Dy. Manager (H&A/Project/Planning)", "+91-11-22441442", "saini[Dot]sushil73[at]gmail[Dot]com"],
    ["21", "Sh. Brij Mohan", "Assistant Manager (CMD-Sectt)", "+91-11-22441635", "nmdfc[Dot]brij[at]gmail[Dot]com"],
    ["22", "Smt. Urmila Kumari", "Assistant Manager (CS)", "+91-11-22441442", "u[Dot]kumari35[at]nic[Dot]in"],
    ["23","Ms . Harshita Rajouria"," Assistant Manager (Finance/Acts)","+91-11-22441442","harshitanmdfc[at]gmail[Dot]com"],
    ["24"," Ms. Poonam  "," Assistant Manager (Project/Coordination)", "+91-11-22441442","poonamnmdfc[at]gmail[Dot]com"],
    ["25","Ms. Mahima"," Assistant Manager (H&A)","+91-11-22441442","mahima[Dot]nmdfc[at]gmail[Dot]com"],
  ];

  return (
    <Container>
      <Table>
        <Thead>
          <tr>
            <Th>S.No.</Th>
            <Th>Employee Name</Th>
            <Th>Designation</Th>
            <Th>Contact No.</Th>
            <Th>Email ID</Th>
          </tr>
        </Thead>
        <tbody>
          {data.map((row, index) => (
            <Tr key={index}>
              {row.map((cell, i) => (
                <Td key={i}>{cell}</Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default OurTeamContent;
